import React from "react";
import Controls from "./Controls";
import NextButton from '../NextButton/NextButton'

function Details(props) {
  const pageType = window.location.pathname.split("/")[1];

  return (
    <div className="c-player--details">
      <div className="details-img">
        <img src={props.song.imgLink} alt="" />
      </div>
      <Controls
        isPlaying={props.isPlaying}
        setIsPlaying={props.setIsPlaying}
        SkipSong={props.SkipSong}
        playSong={props.playSong}
      />

      {pageType === "song" ? (
        <>
          <h3 className="details-title">{props.song.title}</h3>
          <h4 className="details-artist">{props.song.artist}</h4>
          <div className="flex w-full text-white justify-center"><NextButton /></div>
        </>
      ) : (
        <div className="flex space-x-2 justify-center">
          <button
            value={props.song.matchId}
            id={props.id}
            onClick={props.sendVoting}
            type="button"
            className="inline-block border-2 px-6 py-2 border-indigo-600 text-white font-medium hover:font-semibold lg:text-lg md:text-md text-sm uppercase rounded-md hover:bg-indigo-600 cursor-pointer"
          >
            {props.buttonText}
          </button>
        </div>
      )}
    </div>
  );
}

export default Details;
